<template>
    <div class="form-group" :class="{'dark': getDesign() == 'black', 'white' : getDesign() == 'white'}">
        <input
            type="email"
            :class="{
                'required-field': field.isRequired,
                'no-input-error': !hasError && hasTyped,
                'yes-input-error': hasError && hasTyped
            }"
            :placeholder="$t(field.name)"
            v-model="value"
            :required="field.isRequired"
            @input="onInput"
            @change="changeInput"
        >
        <span class="email-error" :class="{ show: hasError }">
            {{ $t("InvalidEmail") }}
        </span>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: "input-normal-mail",
    props: ["field"],
    data() {
        return {
            value: '',
            hasError: false,
            hasTyped: false
        }
    },
    computed: {
        ...mapGetters(['getDesign', 'getCheckout'])
    },
    created() {
        this.value = this.getCheckout().mail || '';
    },
    methods: {
        ...mapMutations(['updateCheckoutField']),
        changeInput() {
            this.updateCheckoutField({ name: 'mail', value: this.value });

            if (this.getCheckout().id) {
                this.$emit('change-field');
            }
        },
        onInput() {
            this.hasTyped = true;
            this.hasError = this.hasTyped && !this.validateEmail(this.value);
        },
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        }
    }
}
</script>

<style lang="scss" scoped>
.email-error {
    color: #c74646;
    font-size: 0.94rem;
    display: none;

    &.show {
        display: flex;
    }
}

.no-input-error {
    background-color: none!important;
}

.yes-input-error {
    background-color: #ffcccc!important;
}
</style>
